// The login saga has been removed — Auth0 SDK handles login via
// loginWithRedirect() in the Login component. No Redux saga needed.

export function* watchMisc() {
    // No sagas to watch. Kept as a placeholder since store.ts calls miscSagaMiddleware.run(watchMisc).
}
